import { api, ENDPOINTS } from '../config';
import type { BlueprintResponseData } from './types'

/**
 * Fetch devices with optional filters
 */
export async function getBlueprints(): Promise<BlueprintResponseData[]> {
  const response = await api.get(ENDPOINTS.BLUEPRINTS);
  
  return response.data;
}